<template>

    <!-- Ligne informations -->
    <div class="highlighted jumbotron">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="region region-highlighted">
                        <!-- Mise en place des Navbars -->
                        <nav class="navbar navbar-default" role="navigation">
                            <div class="navbar-header region-highlighted">
                                <section class="block block-block clearfix">
                                    <p>
                                        <a :href="urlEnSavoirPlus" target="_blank">{{$t('general.enSavoirPlus')}}</a>
                                    </p>
                                </section>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'en-savoir-plus',
  computed: {
    ...mapGetters({
      urlEnSavoirPlus: 'getUrlEnSavoirPlus',
    }),
  },
};
</script>

<style scoped>

</style>
